import React from 'react';
import { FaArrowDown, FaArrowUp, FaChevronRight, FaCubes, FaPaperclip } from 'react-icons/fa';
import { formatShipmentCost, formatShipmentDate, getCarrierLabel } from '../../../utils/shipments';
import {
  CARGO_DIRECTION,
  getCargoDirection,
  getCargoStatus,
  isCargoOverdue,
} from '../../../utils/companyShipments';
import styles from './CargoTracking.module.css';

// Satırda gösterilecek en anlamlı tarih: teslim › beklenen › gönderim
const primaryDate = (shipment) => {
  if (shipment.deliveredAt) return { label: 'Teslim', value: shipment.deliveredAt };
  if (shipment.expectedAt) return { label: 'Beklenen', value: shipment.expectedAt };
  if (shipment.shippedAt) return { label: 'Gönderim', value: shipment.shippedAt };
  return null;
};

/** Kargo satırları. Satıra tıklamak detay panelini açar. */
const CargoList = ({ shipments, showOwner, onSelect }) => (
  <ul className={styles.list}>
    {shipments.map((shipment) => {
      const direction = getCargoDirection(shipment.direction);
      const status = getCargoStatus(shipment.direction, shipment.status);
      const DirectionIcon = direction.value === CARGO_DIRECTION.INCOMING ? FaArrowDown : FaArrowUp;
      const date = primaryDate(shipment);
      const overdue = isCargoOverdue(shipment);
      const cost = formatShipmentCost(shipment.cost);
      const itemCount = (shipment.items || []).length;
      const fileCount = (shipment.attachments || []).length;

      return (
        <li key={shipment.id}>
          <button type="button" className={styles.row} onClick={() => onSelect(shipment)}>
            <span className={`${styles.rowIcon} ${styles[`dir_${direction.value}`]}`} title={direction.label}>
              <DirectionIcon />
            </span>

            <span className={styles.rowMain}>
              <span className={styles.rowTitle}>{shipment.subject}</span>
              <span className={styles.rowMeta}>
                {direction.partyLabel}: {shipment.partyName}
                {shipment.partyOrg ? ` · ${shipment.partyOrg}` : ''}
                {showOwner && shipment.ownerName ? ` · Kayıt: ${shipment.ownerName}` : ''}
              </span>
            </span>

            <span className={styles.rowCarrier}>
              <span>{getCarrierLabel(shipment.carrier) || '—'}</span>
              {shipment.trackingNumber && <code>{shipment.trackingNumber}</code>}
            </span>

            <span className={styles.rowExtras}>
              {itemCount > 0 && (
                <span className={styles.rowChip} title="Bağlı stok kalemi">
                  <FaCubes /> {itemCount}
                </span>
              )}
              {fileCount > 0 && (
                <span className={styles.rowChip} title="Dosya">
                  <FaPaperclip /> {fileCount}
                </span>
              )}
              {cost && <span className={styles.rowCost}>{cost}</span>}
            </span>

            <span className={styles.rowStatus}>
              <span className={`${styles.pill} ${styles[`tone_${overdue ? 'danger' : status.tone}`]}`}>
                {overdue ? 'Gecikti' : status.label}
              </span>
              {date && (
                <small>
                  {date.label}: {formatShipmentDate(date.value)}
                </small>
              )}
            </span>

            <FaChevronRight className={styles.rowChevron} />
          </button>
        </li>
      );
    })}
  </ul>
);

export default CargoList;
